<template>
	<div>
		<label class="caption text-xs-left">{{ labelValue }}</label>
		<v-autocomplete
			class="filter-select shadow-inset select-autocomplete-create"
			:clearable="showClear"
			:menu-props="menuProps"
			hide-details
			no-data-text="No se encontraron resultados para su búsqueda"
			:search-input.sync="search"
			:id="id"
			v-bind="$attrs"
			:tabindex="tabindex"
			@input="setData"
			@click:clear="handleClear"
		>
			<template slot="no-data">
				<v-list-tile-content class="pl-2">
					<v-list-tile-title>No se encontraron resultados para su búsqueda</v-list-tile-title>
				</v-list-tile-content>
			</template>
			<template slot="default" slot-scope="item">
				<v-list-tile-content v-if="item.item.btn" class="btn-item">
					<v-list-tile-title v-html="newRegisterText"></v-list-tile-title>
				</v-list-tile-content>
				<v-list-tile-content v-else>
					<v-list-tile-title v-html="item.item[newProp]"></v-list-tile-title>
				</v-list-tile-content>
			</template>
			<template slot="append-item">
				<v-list-tile-content v-if="newRegisterText" class="primary pl-2 btn-item">
					<v-list-tile-title v-if="newRegisterText">
						<v-btn
							class="ma-0 btn-auto btn-total btn-transform-none btn-decoration-underline"
							color="white"
							depressed
							flat
							@click="$emit('new-register', this.model)"
						>
							{{ newRegisterText }}
						</v-btn>
					</v-list-tile-title>
				</v-list-tile-content>
			</template>
			<template slot="selection" slot-scope="item">
				<template v-if="!item.item.btn">
					<div class="input-group__selections__comma" :style="styleSelection(item.item[prop])">
						{{ item.item[prop] }}
					</div>
				</template>
			</template>
		</v-autocomplete>
	</div>
</template>

<script>
function cleanData(newValue) {
	if (newValue) {
		this.search = null;
	}
}

function menuProps() {
	const classNoData = !!this.search && this.noData ? 'select-autocomplete-create-content-open' : '';
	return {
		contentClass: `filter-select-content select-autocomplete-create-content ${classNoData}`,
	};
}

function newProp() {
	return this.propSearch || this.prop;
}

function search(value) {
	this.$emit('search', value);
	if (!value) {
		this.setData(value);
	}
}

function setData(itemData) {
	if (itemData) {
		this.$emit('set-data', itemData);
	} else {
		this.search = null;
	}
}

function handleClear() {
	this.search = null; // Limpiar el campo de búsqueda
	this.$emit('set-data', null); // Emitir null para restablecer el modelo en el componente padre
}

function styleSelection(item) {
	if (item.length === 29) {
		return 'position: relative; top: 0px';
	} else if (item.length > 29) {
		return 'position: relative; top: 44px';
	} else if (item.length > 44) {
		return 'position: relative; top: 63px';
	}
	return '';
}

function data() {
	return {
		newItems: [],
		search: null,
	};
}

export default {
	name: 'select-autocomplete-create',
	computed: {
		menuProps,
		newProp,
	},
	data,
	inheritAttrs: false,
	methods: {
		setData,
		styleSelection,
		handleClear,
	},
	props: {
		id: [String, Number],
		labelValue: {
			type: String,
		},
		model: String,
		newRegisterText: String,
		noData: {
			default: false,
			type: Boolean,
		},
		prop: String,
		propSearch: String,
		tabindex: [Number, String],
		showClear: {
			default: false,
			type: Boolean,
		},
	},
	watch: {
		cleanData,
		search,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/autocomplete/select-autocomplete-create.vue